<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <AxpressoContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import AxpressoContent from "~~/codepresso-renewal/content/AxpressoContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "AXpresso: AI 업무 자동화 | 코드프레소",
  meta: [
    { name: "description", content: "흩어진 도구와 수작업을 AI 중심 자동화 흐름으로 연결합니다. 빠른 도입으로 실제 운영까지 연결하는 AI 업무 자동화 플랫폼입니다." },
    { name: "title", content: "AXpresso: AI 업무 자동화 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "AXpresso: AI 업무 자동화 | 코드프레소" },
    { property: "og:description", content: "흩어진 도구와 수작업을 AI 중심 자동화 흐름으로 연결합니다. 빠른 도입으로 실제 운영까지 연결하는 AI 업무 자동화 플랫폼입니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/axpresso.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
